<div (click)="onClose()"
     class="alert-box">
  <br>
  <br>
  <p class="bold-center title-center verification-text">{{ verifCode }}</p>
  <p [ngStyle]="!isMobile && {'font-size': '1.5rem'}"
     class="text-center">{{ "login.verificationCheck" | translate }}</p>
  <p [ngStyle]="!isMobile && {'font-size': '1.2rem'}" class="text-center">{{ timeOutText }}</p>

</div>
